import { hotList } from "@/mocks/guagua";

export default function Trending() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <p className="text-xs md:text-sm font-medium tracking-wide text-accent-600">
              🔥 前排围观中
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              今日热榜 · 大家都爱看这些
            </h2>
          </div>
          <p className="text-xs md:text-sm text-foreground-500">
            每 30 分钟自动刷新 · 数据来自同学围观热度
          </p>
        </div>

        <div className="mt-8 grid gap-4 md:gap-5 lg:grid-cols-2">
          {hotList.map((item) => (
            <a
              href="#feed"
              key={item.rank}
              className="group flex items-center gap-4 rounded-2xl bg-background-50 border border-background-200 p-4 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-lg ${
                  item.rank <= 3
                    ? "bg-primary-500 text-background-50"
                    : item.rank <= 5
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-200 text-secondary-900"
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </p>
                <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-background-100 px-2 py-0.5 whitespace-nowrap">{item.tag}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {item.heat}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-heart-3-fill text-primary-400"></i>
                    {item.up}
                  </span>
                </div>
              </div>
              {item.rank <= 3 && (
                <span className="hidden sm:inline-flex text-xl" aria-hidden="true">
                  {["🥇", "🥈", "🥉"][item.rank - 1]}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}